import React from 'react'
import ModalDialog from '../containers/ModalDialog'
import { ToastContainer } from 'react-toastify'
import Header from '../containers/Header'
import AppModesSwitcher from '../containers/AppModesSwitcher'
import TradingChart from '../containers/TradingChart'
import PositionsPane from '../containers/PositionsPane'
import BondPositionsPane from '../containers/BondPositionsPane'
import BondsList from '../containers/BondsList'
import BondsPane from '../containers/BondsPane'
import Spinner from './Spinner'
import { BondListState, AppType, PositionsInputs, AppMode } from '../types'
import { TradingAccount, PricesExtended, TradeObject } from '@bdswiss/mt4-connector'
import AssetsSelect from '../containers/AssetsSelect'
import BondDetailView from '../containers/BondDetailView'
import Sidebar from '../containers/Sidebar'

export interface Props {
  loginInfo: TradingAccount
  locale: string
  accountLoaded: boolean
  bondListState: BondListState
  appType: AppType
  assetsOpened: boolean
  positionsOpened: boolean
  assets: PricesExtended
  positions: Map<number, TradeObject>
  pendingOrders: Map<number, TradeObject>
  positionsInputs: PositionsInputs
  currency: string
  tradeOperationEnabled: boolean
  selectedPosition?: number
  appMode: AppMode
}

const App = ({
  loginInfo,
  locale,
  accountLoaded,
  bondListState,
  appType,
  assetsOpened,
  positionsOpened,
  appMode,
}: Props) => {
  if (!loginInfo || !locale || !accountLoaded) {
    return (
      <div>
        <ToastContainer />
        <Spinner />
      </div>
    )
  }

  let webtraderBody: JSX.Element = <div />
  if (appType === 'bond') {
    const bondListBody: JSX.Element = bondListState.viewBondDetails ? (
      <BondDetailView />
    ) : (
      <BondsList />
    )
    webtraderBody = (
      <div className="prime-wrap d-flex">
        <BondPositionsPane />
        <div className="d-flex flex-column no-scrolling midle-wrap">{bondListBody}</div>
        <BondsPane />
        <ModalDialog />
        <ToastContainer />
      </div>
    )
  } else {
    const paneOpened = positionsOpened || assetsOpened
    webtraderBody = (
      <div className="prime-wrap d-flex">
        <div className="d-flex flex-column no-scrolling">
          <div className={'select-assets d-flex flex-column' + (paneOpened ? ' show' : '')}>
            {positionsOpened && <PositionsPane />}
            {assetsOpened && <AssetsSelect />}
          </div>
          {!(positionsOpened && appMode === 'history') && <TradingChart />}
        </div>
        <Sidebar />
      </div>
    )
  }
  return (
    <div className="d-flex flex-column no-scrolling">
      <ToastContainer />
      <ModalDialog />
      <Header />
      <div className="d-flex flex-row no-scrolling">
        <AppModesSwitcher />
        {webtraderBody}
      </div>
    </div>
  )
}

export default App
